'use client';

// import { CustomImage as Image } from '..';
import { useGsapContext } from 'hooks/animation/useGsapContext';
import { HTMLAttributes, useRef } from 'react';
import { useIsomorphicLayoutEffect } from 'hooks/dom/useIsomorphicLayoutEffect';
import { Container } from '../..';
import gsap from 'gsap';
import { useMasterTimeline } from 'hooks/animation/useMasterTimeline';
import { splitTextIntoSpans } from 'components/shared/SplitTextIntoSpans';
// import { useWindowSize } from 'hooks/dom/useWindowSize';
import styles from './SolidBgTextSection.module.css';

const PLarge = ({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) => (
  <p
    className={className ? `${styles.pLarge} ${className}` : styles.pLarge}
    {...props}
  />
);

export const SolidBgTextSection = ({
  className,
  backgroundColor,
}: {
  className?: string;
  backgroundColor?: string;
}) => {
    // const { width } = useWindowSize();
    const gsapContext = useGsapContext();
    const { add } = useMasterTimeline();

    const container = useRef<HTMLDivElement>(null);

    const animationInit = () => {
      if (!container.current || !window) return;

      gsapContext.add(() => {
        const tl = gsap.timeline({
          defaults: {
            duration: 1,
            ease: 'power2.easeInOut',
          },
          scrollTrigger: {
            trigger: container.current,
            start: 'top top',
            end: 'bottom bottom',
            scrub: 0.2,
            immediateRender: false,
          },
        });

        tl.set(`.tc-1 > span`, {
          autoAlpha: 0.2,
        });

        tl.fromTo(
          '.tc-1 > span',
          {
            autoAlpha: 0.2,
          },
          {
            autoAlpha: 1,
            duration: 0.35,
            stagger: 0.2,
          },
          0.2,
        );

        // tl.to(`.tc-1 > span`, {
        //   autoAlpha: 0.2,
        //   duration: 0.35,
        // });

        // tl.fromTo(
        //   '.tc-2 > span',
        //   {
        //     autoAlpha: 0,
        //   },
        //   {
        //     autoAlpha: 0.2,
        //     duration: 0.35,
        //     stagger: 0.2,
        //   },
        //   '+=0.5',
        // );

        // tl.fromTo(
        //   '.tc-2 > span',
        //   {
        //     autoAlpha: 0.2,
        //   },
        //   {
        //     autoAlpha: 1,
        //     duration: 0.35,
        //     stagger: 0.2,
        //   },
        // );

        add(tl, 'buy-solid-bg-text');
      });
    };

    const intersectionObserver = useRef<IntersectionObserver | null>(null);

    useIsomorphicLayoutEffect(() => {
      intersectionObserver.current = new IntersectionObserver(
        () => {
          animationInit();
        },
        {
          root: null,
          rootMargin: '100px',
          threshold: 0,
        },
      );

      intersectionObserver.current.observe(container.current as Element);

      return () => {
        if (intersectionObserver.current) {
          intersectionObserver.current.disconnect();
        }
      };
    }, []);

    return (
      <section
        className={className ? `${styles.root} ${className}` : styles.root}
        ref={container}
        style={{ background: backgroundColor }}
      >
        <div className="sticky-wrapper">
          <Container
            style={{
              position: 'relative',
              height: '100%',
              display: 'grid',
              placeItems: 'center',
            }}
          >
            <PLarge className="text-content tc-1">
              {splitTextIntoSpans('Fashion forward. Future powered.')}
            </PLarge>
          </Container>
        </div>
      </section>
    );
};
